module.exports = __webpack_public_path__ + "img/4.d63bf01.jpg";